import { action, observable, makeAutoObservable } from "mobx"

import type { PagedResultDto } from "@services/dto/pagedResultDto"
import wfStatusService from "@services/workflow/wfStatusService"
import { initMultiLanguageField } from "@lib/helper"

class WfStatusStore {
  @observable isLoading!: boolean
  @observable tableData!: PagedResultDto<any>
  @observable detailData!: any
  constructor() {
    makeAutoObservable(this)
    this.isLoading = false
  }
  @action
  async create(createWfStatusInput) {
    this.isLoading = true
    await wfStatusService
      .create(createWfStatusInput)
      .finally(() => (this.isLoading = false))
  }

  @action
  async update(updateWfStatusInput) {
    this.isLoading = true
    await wfStatusService
      .update(updateWfStatusInput)
      .finally(() => (this.isLoading = false))
  }

  @action
  async activateOrDeactivate(id: number, isActive) {
    await wfStatusService.activateOrDeactivate(id, isActive)
  }

  @action
  async get(id) {
    this.isLoading = true
    this.detailData = await wfStatusService
      .get({ id })
      .finally(() => (this.isLoading = false))
  }

  @action
  async createWfStatus() {
    this.detailData = {
      id: 0,
      names: initMultiLanguageField(),
      isActive: true,
    }
  }

  @action
  async getAll(body: any) {
    this.isLoading = true
    this.tableData = await wfStatusService
      .getAll(body)
      .finally(() => (this.isLoading = false))
  }

  @action
  async updateSortList(ids: number[]) {
    await wfStatusService.updateSortList(ids)
  }
}

export default WfStatusStore
